export interface BlogListingSettings {
  cardsPerRow: number;
  showSearch: boolean;
  showFilter: boolean;
}

export const defaultBlogListingSettings: BlogListingSettings = {
  cardsPerRow: 3,
  showSearch: true,
  showFilter: true,
};

function parseJson(raw: unknown): Record<string, unknown> {
  if (!raw) return {};
  if (typeof raw === 'object') return raw as Record<string, unknown>;
  if (typeof raw !== 'string') return {};
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? (parsed as Record<string, unknown>) : {};
  } catch {
    return {};
  }
}

function asBool(value: unknown, fallback: boolean): boolean {
  if (value == null || value === '') return fallback;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value !== 0;
  if (typeof value === 'string') {
    const n = value.trim().toLowerCase();
    if (n === 'true' || n === '1') return true;
    if (n === 'false' || n === '0') return false;
  }
  return fallback;
}

function asRowCount(value: unknown, fallback: number): number {
  const num = Number(value);
  return [2, 3, 4].includes(num) ? num : fallback;
}

export function extractBlogListing(rawHeroSettingsJson: unknown): BlogListingSettings {
  const json = parseJson(rawHeroSettingsJson);
  const extras = json.blogListing;
  const src = extras && typeof extras === 'object' ? (extras as Record<string, unknown>) : {};
  return {
    cardsPerRow: asRowCount(src.cardsPerRow, defaultBlogListingSettings.cardsPerRow),
    showSearch: asBool(src.showSearch, defaultBlogListingSettings.showSearch),
    showFilter: asBool(src.showFilter, defaultBlogListingSettings.showFilter),
  };
}

export function embedBlogListingInHeroJson(
  heroSettingsJson: string,
  listing: BlogListingSettings
): string {
  const json = parseJson(heroSettingsJson);
  json.blogListing = {
    cardsPerRow: asRowCount(listing.cardsPerRow, defaultBlogListingSettings.cardsPerRow),
    showSearch: Boolean(listing.showSearch),
    showFilter: Boolean(listing.showFilter),
  };
  return JSON.stringify(json);
}
